import { z } from 'zod';
export const createSeasonSchema = z.object({
    podcastId: z.string().uuid(),
    number: z.number().int().positive(),
    title: z.string().max(200).optional(),
});
export const updateSeasonSchema = z.object({
    number: z.number().int().positive().optional(),
    title: z.string().max(200).nullable().optional(),
});
//# sourceMappingURL=season.schemas.js.map